<template>
  <a @click="toggleCircle" :class="'fa ' + faCircle + ' icon_check'" class="color-skin"></a>
</template>

<script>
export default {
  name: 'todo-checkbox',
  data () {
    return {
      checkVal: this.value
    }
  },
  computed: {
    faCircle () {
      if (this.checkVal === 'Y') {
        return 'fa-check-circle'
      } else if (this.checkVal === 'N') {
        return 'fa-circle-o'
      }
    }
  },
  props: ['value'],
  methods: {
    toggleCircle () {
      if (this.checkVal === 'Y') {
        this.checkVal = 'N'
      } else if (this.checkVal === 'N') {
        this.checkVal = 'Y'
      }
      this.$emit('input', this.checkVal)
      this.$emit('saveTodoListChecked')
    }
  }
}
</script>


// WEBPACK FOOTER //
// todoCheckbox.vue?a56901d2